module.exports = __webpack_public_path__ + "static/media/arrow-left.3d6cae6d.svg";